<template>
  <InlineLayoutDropdownButton
    ref="menu"
    :label="label"
    :icon="getOptionValue(IconOption)"
    :variant="getOptionValue(ButtonType)"
    :size="getOptionValue(ButtonSize)"
  >
    <ContainerProduction v-bind="containerProps" @click="closeMenu">
      <slot />
    </ContainerProduction>
  </InlineLayoutDropdownButton>
</template>

<script>
import InlineLayoutDropdownButton from "@bloglovin/inspire-engine/DynamicComponents/Components/InlineLayoutDropdownButton.vue";
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import TextOption from "%/dynamic-component-editor/options/text-option";
import IconOption from "%/dynamic-component-editor/options/icon";
import ButtonType from "%/dynamic-component-editor/options/button-type";
import ButtonSize from "%/dynamic-component-editor/options/button-size";

// The engine DropdownButton owns the trigger and the popover; the DCE container lays out its items. Choosing an item closes it.
export default {
  name: "DropdownButtonContainer",
  components: { InlineLayoutDropdownButton, ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin],
  inheritAttrs: false,
  data() {
    return { IconOption, ButtonType, ButtonSize };
  },
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
    label() {
      const value = this.getOptionValue(TextOption);
      return typeof value === "string" ? value : value?.body_text ?? "";
    },
  },
  methods: {
    closeMenu() {
      this.$refs.menu?.closeMenu();
    },
  },
};
</script>
